import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Mail, ExternalLink } from 'lucide-react';

const Privacybeleid = () => {
  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-block bg-[#FDB913] rounded-full p-4 mb-4">
            <Shield size={40} className="text-foreground" />
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-2">Privacybeleid</h1>
          <p className="text-muted-foreground">Hoe wij omgaan met je gegevens</p>
        </div>

        <Card className="border-2 border-[#FDB913]">
          <CardContent className="pt-6 prose prose-lg max-w-none">
            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes met de daaronder hangende pooltjes is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.
            </p>

            {/* Wie zijn we */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Wie zijn we</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Ons site adres is: <a href="https://f1.sportpooltjes.nl" className="text-[#FDB913] hover:underline">https://f1.sportpooltjes.nl</a>
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Robin Mak is de Functionaris Gegevensbescherming van Sportpooltjes. Hij is te bereiken via{' '}
              <a href="mailto:info@sportpooltjes.nl" className="text-[#FDB913] hover:underline">info@sportpooltjes.nl</a>
            </p>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes, onderdeel van personeelsvereniging SPV The Fun Club, wordt aangeboden voor personeelsleden waar SPV The Fun Club onderdeel van is. Sportpooltjes en SPV The Fun Club hebben geen winstoogmerk en zullen alle ingelegde gelden minus administratiekosten uitkeren aan de ingeschreven deelnemers. Daarnaast kunnen er diverse prijzen in natura verloot worden onder de deelnemers. Dit alles zal gecontroleerd worden door de penningmeester van SPV The Fun Club en alle prijzen zullen na controle uitgekeerd worden door de penningmeester van SPV The Fun Club.
            </p>

            {/* Persoonsgegevens */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Persoonsgegevens die wij verwerken</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Sportpooltjes verwerkt je persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt. Hieronder vind je een overzicht van de persoonsgegevens die wij verwerken:
            </p>
            <ul className="list-disc list-inside text-muted-foreground mb-6 space-y-1">
              <li>Gebruikersnaam</li>
              <li>E-mailadres</li>
              <li>Personeelsnummer</li>
            </ul>

            {/* Bijzondere gegevens */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Bijzondere en/of gevoelige persoonsgegevens die wij verwerken</h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 18 jaar. Tenzij ze toestemming hebben van ouders of voogd. We kunnen echter niet controleren of een bezoeker ouder dan 18 is. Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen, om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming. Als je er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige, neem dan contact met ons op via info@sportpooltjes.nl, dan verwijderen wij deze informatie.
            </p>

            {/* Doel verwerking */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Sportpooltjes verwerkt jouw persoonsgegevens voor de volgende doelen:
            </p>
            <ul className="list-disc list-inside text-muted-foreground mb-6 space-y-1">
              <li>Verzenden van onze nieuwsbrief</li>
              <li>Verzenden van de standen</li>
              <li>Je te informeren over wijzigingen van onze diensten en producten</li>
            </ul>

            {/* Bewaartermijn */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Hoe lang we persoonsgegevens bewaren</h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes bewaart je persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor je gegevens worden verzameld.
            </p>

            {/* Delen met derden */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Delen van persoonsgegevens met derden</h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes verstrekt nooit informatie over jou aan derden. Wel zal Sportpooltjes je naam gebruiken om een actuele stand op te maken, en deze te publiceren op de website.
            </p>

            {/* Cookies */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Cookies, of vergelijkbare technieken, die wij gebruiken</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Sportpooltjes gebruikt functionele, analytische en tracking cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen in de browser van je computer, tablet of smartphone. Sportpooltjes gebruikt cookies met een puur technische functionaliteit. Deze zorgen ervoor dat de website naar behoren werkt en dat bijvoorbeeld jouw voorkeursinstellingen onthouden worden. Deze cookies worden ook gebruikt om de website goed te laten werken en deze te kunnen optimaliseren. Daarnaast plaatsen we cookies die jouw surfgedrag bijhouden zodat we op maat gemaakte content en advertenties kunnen aanbieden.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Bij jouw eerste bezoek aan onze website hebben wij je al geïnformeerd over deze cookies. Je kunt je afmelden voor cookies door je internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kun je ook alle informatie die eerder is opgeslagen via de instellingen van je browser verwijderen.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Zie voor een toelichting:{' '}
              <a 
                href="https://veiliginternetten.nl/themes/situatie/cookies-wat-zijn-het-en-wat-doe-ik-ermee/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#FDB913] hover:underline inline-flex items-center"
              >
                veiliginternetten.nl <ExternalLink size={14} className="ml-1" />
              </a>
            </p>

            {/* Ingesloten inhoud */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Ingesloten inhoud van andere sites</h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Berichten op deze site kunnen ingesloten inhoud bevatten (bijvoorbeeld video's, afbeeldingen, berichten, enz.). Ingesloten inhoud van andere sites gedraagt zich exact hetzelfde alsof de bezoeker deze andere site heeft bezocht. Deze sites kunnen gegevens over je verzamelen, cookies gebruiken, extra tracking van derde partijen insluiten en je interactie met deze ingesloten inhoud monitoren, inclusief het vastleggen van de interactie met ingesloten inhoud als je een account hebt en ingelogd bent op die site.
            </p>

            {/* Gegevens inzien */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Gegevens inzien, aanpassen of verwijderen</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Dit kun je zelf doen via de persoonlijke instellingen van jouw account. Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van jouw persoonsgegevens door Sportpooltjes en heb je het recht op gegevensoverdraagbaarheid.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Dat betekent dat je bij ons een verzoek kan indienen om de persoonsgegevens die wij van jou beschikken in een computerbestand naar jou of een ander, door jou genoemde organisatie, te sturen. Wil je gebruik maken van je recht op bezwaar en/of recht op gegevensoverdraagbaarheid of heb je andere vragen/opmerkingen over de gegevensverwerking, stuur dan een gespecificeerd verzoek naar info@sportpooltjes.nl.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Om er zeker van te zijn dat het verzoek tot inzage door jou is gedaan, vragen wij jou een kopie van je identiteitsbewijs bij het verzoek mee te sturen. Maak in deze kopie je pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van je privacy. Sportpooltjes zal zo snel mogelijk, maar in ieder geval binnen vier weken, op jouw verzoek reageren.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Sportpooltjes wil je er tevens op wijzen dat je de mogelijkheid hebt om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link:{' '}
              <a 
                href="https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#FDB913] hover:underline inline-flex items-center"
              >
                Autoriteit Persoonsgegevens <ExternalLink size={14} className="ml-1" />
              </a>
            </p>

            {/* Beveiliging */}
            <h2 className="text-xl font-bold text-foreground mt-8 mb-4">Hoe wij persoonsgegevens beveiligen</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Sportpooltjes neemt de bescherming van jouw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als jij het idee hebt dat jouw gegevens toch niet goed beveiligd zijn of er zijn aanwijzingen van misbruik, neem dan contact op met onze klantenservice of via info@sportpooltjes.nl.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Sportpooltjes heeft de volgende maatregelen genomen om jouw persoonsgegevens te beveiligen:
            </p>
            <ul className="list-disc list-inside text-muted-foreground mb-6 space-y-1">
              <li>Beveiligingssoftware, zoals een virusscanner en firewall.</li>
              <li>TLS (voorheen SSL) Wij versturen jouw gegevens via een beveiligde internetverbinding. Dit kun je zien aan de adresbalk 'https' en het hangslotje in de adresbalk.</li>
            </ul>

            {/* Contact */}
            <div className="mt-8 pt-6 border-t border-border">
              <h3 className="text-lg font-semibold text-foreground mb-4">Contact</h3>
              <a 
                href="mailto:info@sportpooltjes.nl" 
                className="inline-flex items-center text-[#FDB913] hover:underline"
              >
                <Mail className="mr-2" size={18} />
                info@sportpooltjes.nl
              </a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Privacybeleid;
